<!-- DEPRECATED ? -->
<!-- Use Form/SmoothToggleSwitch instead -->

<template>
    <label class="inline w-11 items-center cursor-pointer">
        <input
            :id="id"
            type="checkbox"
            class="sr-only peer"
            :checked="modelValue"
            @change="toggle"
        />
        <div
            class="relative h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-branding-green-light dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-branding-green dark:peer-checked:bg-branding-green"
        ></div>

        <span
            v-if="label"
            class="pl-3 text-sm font-medium text-branding-mid-grey dark:text-gray-300"
        >
            {{ label }}
        </span>
        <span
            v-if="tooltip"
            :data-tooltip="tooltip"
            class="ml-1 text-sm font-medium text-branding-mid-grey dark:text-gray-300"
        >
            <i class="fa-regular fa-circle-info" />
        </span>
    </label>
</template>

<script setup lang="ts">
    const props = defineProps<{
        modelValue: boolean;
        label?: string;
        tooltip?: string;
        id?: string;
    }>();

    const emit = defineEmits<{
        (e: 'update:modelValue', value: boolean): void;
    }>();

    const toggle = () => emit('update:modelValue', !props.modelValue);
</script>
